// Limite de dígitos da conta corrente, incluindo o dígito verificador: padrão
// FEBRABAN/CNAB (até 12 dígitos de conta + 1 DV). Contas de bancos digitais
// e SCDs passam com folga dos 6 dígitos que eram aceitos antes.
export const CURRENT_ACCOUNT_MAX_DIGITS = 13;

export function formatCurrentAccount(value: unknown): string {
  if (!value) return '';
  const strValue = String(value);
  const cleaned = strValue.replace(/\D/g, '').slice(0, CURRENT_ACCOUNT_MAX_DIGITS); // Remove não numéricos
  return cleaned.replace(/^(\d+)(\d)$/, '$1-$2'); // Adiciona hífen antes do último dígito
}
